import { render, staticRenderFns } from "./LoginDetails.vue?vue&type=template&id=2a4a6e2e&scoped=true"
import script from "./LoginDetails.vue?vue&type=script&lang=js"
export * from "./LoginDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a6e2e",
  null
  
)

export default component.exports